import DefaultMapper from '../../dataProvider/DefaultMapper'

class AccountingAccountItemMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'accounting/accountitems'
	}
}

export default AccountingAccountItemMapper
